import { UserRoles } from 'constants/users/userRolesAndTypes';

export const isAllowedForUserRole = (arrayOfRolesThatHasAccess: UserRoles[], userRole: UserRoles) => !!arrayOfRolesThatHasAccess.includes(userRole);
